<div class="markdown-container" [innerHTML]="sanitizedHtml" [style.font-size.px]="fontSize()"></div>
